<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <ion-label class="title"> {{ title }} </ion-label>
  <p *ngIf="info" [innerHTML]="info"></p>
  <h4 *ngIf="subtitle" [innerHTML]="subtitle"></h4>
  <p [innerHTML]="body"></p>
  <p [innerHTML]="body2"></p>
  <p [innerHTML]="note" class="note"></p>
  <ion-button *ngIf="ctaText" expand="block" (click)="continue()" mode="ios">{{ ctaText }}</ion-button>
  <ion-button *ngIf="cancelButton" class="button-cancel" mode="ios" color="light" expand="block" (click)="dismiss()"
    >{{ cancelButton }}</ion-button
  >
</ion-content>
